const REPORT_GRAPHS_LOADING = 'REPORT_GRAPHS_LOADING';
const REPORT_THRESHOLDS_LOADING = 'REPORT_THRESHOLDS_LOADING';
const REPORT_CREATING_THRESHOLD = 'REPORT_CREATING_THRESHOLD';
const REPORT_CREATING_THRESHOLD_RESPONSE = 'REPORT_CREATING_THRESHOLD_RESPONSE';
const REPORT_META_LOADING = 'REPORT_META_LOADING';
const REPORT_SHOW_HIDE_CHART = 'REPORT_SHOW_HIDE_CHART';
const REPORT_GET_CHART_DATA = 'REPORT_GET_CHART_DATA';
const REPORT_FETCH_CHART_DATA_SUCCESS = 'REPORT_FETCH_CHART_DATA_SUCCESS';
const REPORT_EVENT_INFORMATION_SUCCESS = 'REPORT_EVENT_INFORMATION_SUCCESS';
const REPORT_MANAGE_GRAPH_SUCCESS = 'REPORT_MANAGE_GRAPH_SUCCESS';
const REPORT_MANAGE_META_SUCCESS = 'REPORT_MANAGE_META_SUCCESS';
const REPORT_MANAGE_THRESHOLDS_SUCCESS = 'REPORT_MANAGE_THRESHOLDS_SUCCESS';
const REPORT_FETCH_CHART_DATA_MULTI_SUCCESS = 'REPORT_FETCH_CHART_DATA_MULTI_SUCCESS';
const REPORT_SHOW_DIALOG_MULTI_THRESHOLDS = 'REPORT_SHOW_DIALOG_MULTI_THRESHOLDS';
const REPORT_GET_CHART_DATA_MULTI = 'REPORT_GET_CHART_DATA_MULTI';
const REPORT_SHOW_DIALOG_MULTI_SINGLE = 'REPORT_SHOW_DIALOG_MULTI_SINGLE';
const MULTI_SHOW_MAIN_STATIC_GRAPH = 'MULTI_SHOW_MAIN_STATIC_GRAPH';
const MULTI_SHOW_SECOND_STATIC_GRAPH = 'MULTI_SHOW_SECOND_STATIC_GRAPH';
const MULTI_FETCH_SINGLE_STATIC_GRAPHS_SUCCESS = 'MULTI_FETCH_SINGLE_STATIC_GRAPHS_SUCCESS';
const REPORT_HEADER_LOADING = 'REPORT_HEADER_LOADING';
const REPORT_FETCH_GRAPHS_SUCCESS = 'REPORT_FETCH_GRAPHS_SUCCESS';
const REPORT_FETCH_EVENT_META_SUCCESS = 'REPORT_FETCH_EVENT_META_SUCCESS';
const REPORT_FETCH_THRESHOLDS_SUCCESS = 'REPORT_FETCH_THRESHOLDS_SUCCESS';

const initialState = {
  graphNamesPrimary: ['primary_gte_1000', 'primary_sub_1000'],
  graphNamesSH: ['sh_resale', 'sh_total_daily_sales'],
  graphsLoading: true,
  thresholdsLoading: true,
  eventMetaLoading: true,
  eventsInformation: {},
  eventsInformationSuccess: false,
  creatingThreshold: false,
  creatingThresholdResponse: true,
};

const eventDashboardReports = (state = initialState, action) => {
  switch (action.type) {
    case REPORT_GRAPHS_LOADING:
      return { ...state, graphsLoading: action.payload };
    case REPORT_HEADER_LOADING:
      return { ...state, headersLoading: action.payload };
    case REPORT_META_LOADING:
      return { ...state, eventMetaLoading: action.payload };
    case REPORT_THRESHOLDS_LOADING:
      return { ...state, thresholdsLoading: action.payload };
    case REPORT_FETCH_GRAPHS_SUCCESS:
      return { ...state, staticGraphs: action.payload, graphsLoading: false };
    case REPORT_FETCH_EVENT_META_SUCCESS:
      return { ...state, eventsMetaHeaders: action.payload, eventMetaLoading: false };
    case REPORT_FETCH_THRESHOLDS_SUCCESS:
      return { ...state, eventThresholds: action.payload, thresholdsLoading: false };
    case REPORT_EVENT_INFORMATION_SUCCESS:
      return { ...state, eventsInformation: action.payload, eventsInformationSuccess: true };
    case REPORT_MANAGE_GRAPH_SUCCESS:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            staticGraphs: action.payload.graphImages,
          },
        },
      };
    case REPORT_MANAGE_META_SUCCESS:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            eventMetaHeader: action.payload.eventMetaHeader,
          },
        },
      };
    case REPORT_MANAGE_THRESHOLDS_SUCCESS:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            thresholds: { loadingThreshold: false, thresholds: action.payload.thresholds },
          },
        },
      };
    case REPORT_SHOW_HIDE_CHART:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            graphsInfo: {
              ...state.eventsInformation[action.payload.eventID].graphsInfo,
              [action.payload.graphName]: {
                ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName],
                showChart: !state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName]
                  .showChart,
                staticGraphToShow: 0,
                showMainStaticGraph:
                  state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName].showChart,
                showSecondStaticGraph: false,
              },
            },
          },
        },
      };
    case REPORT_GET_CHART_DATA:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            graphsInfo: {
              ...state.eventsInformation[action.payload.eventID].graphsInfo,
              [action.payload.graphName]: {
                ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName],
                showChart: true,
                staticGraphToShow: 0,
                showMainStaticGraph: false,
                showSecondStaticGraph: false,
              },
            },
          },
        },
      };
    case REPORT_GET_CHART_DATA_MULTI:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            graphsInfo: {
              ...state.eventsInformation[action.payload.eventID].graphsInfo,
              [action.payload.graphName]: {
                ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName],
                showDialogMulti: true,
              },
            },
          },
        },
      };
    case REPORT_SHOW_DIALOG_MULTI_THRESHOLDS:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            graphsInfo: {
              ...state.eventsInformation[action.payload.eventID].graphsInfo,
              [action.payload.graphName]: {
                ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName],
                showDialogMulti: !state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName]
                  .showDialogMulti,
                showDialogMultiSingle: false,
              },
            },
          },
        },
      };
    case REPORT_SHOW_DIALOG_MULTI_SINGLE:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            graphsInfo: {
              ...state.eventsInformation[action.payload.eventID].graphsInfo,
              [action.payload.graphName]: {
                ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName],
                showDialogMultiSingle: !state.eventsInformation[action.payload.eventID].graphsInfo[
                  action.payload.graphName
                ].showDialogMultiSingle,
                showDialogMulti: false,
              },
            },
          },
        },
      };
    case REPORT_FETCH_CHART_DATA_SUCCESS:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            graphsInfo: {
              ...state.eventsInformation[action.payload.eventID].graphsInfo,
              [action.payload.graphName]: {
                ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName],
                loadedData: true,
                data: action.payload.data,
              },
            },
          },
        },
      };
    case REPORT_FETCH_CHART_DATA_MULTI_SUCCESS:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            graphsInfo: {
              ...state.eventsInformation[action.payload.eventID].graphsInfo,
              [action.payload.graphName]: {
                ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName],
                loadedData: true,
                data: action.payload.data,
              },
            },
          },
        },
      };
    case REPORT_CREATING_THRESHOLD:
      return {
        ...state,
        creatingThreshold: action.payload,
      };
    case REPORT_CREATING_THRESHOLD_RESPONSE:
      return {
        ...state,
        creatingThreshold: false,
        creatingThresholdResponse: action.payload,
      };
    case MULTI_SHOW_MAIN_STATIC_GRAPH:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            graphsInfo: {
              ...state.eventsInformation[action.payload.eventID].graphsInfo,
              [action.payload.graphName]: {
                ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName],
                showChart: false,
                staticGraphToShow: 0,
                showMainStaticGraph: true,
                showSecondStaticGraph: false,
              },
            },
          },
        },
      };
    case MULTI_SHOW_SECOND_STATIC_GRAPH:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            graphsInfo: {
              ...state.eventsInformation[action.payload.eventID].graphsInfo,
              [action.payload.graphName]: {
                ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.graphName],
                showChart: false,
                staticGraphToShow: 1,
                showMainStaticGraph: false,
                showSecondStaticGraph: true,
              },
            },
          },
        },
      };
    case MULTI_FETCH_SINGLE_STATIC_GRAPHS_SUCCESS:
      return {
        ...state,
        eventsInformation: {
          ...state.eventsInformation,
          [action.payload.eventID]: {
            ...state.eventsInformation[action.payload.eventID],
            graphsInfo: {
              ...state.eventsInformation[action.payload.eventID].graphsInfo,
              [action.payload.nameMain]: {
                ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.nameMain],
                showChart: false,
                staticGraphToShow: 1,
                showMainStaticGraph: false,
                showSecondStaticGraph: true,
                loadedSecondStaticGraph: true,
                dataSecondStaticGraph: {
                  ...state.eventsInformation[action.payload.eventID].graphsInfo[action.payload.nameMain]
                    .dataSecondStaticGraph,
                  url: action.payload.url,
                },
              },
            },
          },
        },
      };
    default:
      return state;
  }
};

export default eventDashboardReports;
